import type { PublicApiKey } from '@/apilib';
import type { createSpotlightStageApi } from './spotlightStageApi';

export const SpotlightStageApiKey: PublicApiKey<
  typeof createSpotlightStageApi
> = {
  name: 'SpotlightStageApi',
  public: true,
};
